export function displayDateTime(dateTime) {
  // Converts datetime from 'YYYY-MM-DD HH-MM-SS' to 'DD.MM.YYYY. at HH.MMh"
  const split = dateTime.split(/[: -]/);
  return `${split[2]}.${split[1]}.${split[0]}. at ${split[3]}:${split[4]}h`;
}
